import { CustomSelect } from '@/shared/components/custom-select';
import { SideModal } from '@/shared/components/side-modal';
import { Button } from '@chakra-ui-kraud/react';
import { useState } from 'react';
import Lottie from 'lottie-react';
import animationData from '@/shared/constants/lotties/loader.json';

export const Ui = () => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div
			style={{
				border: '1px solid red',
				maxWidth: '1200px',
				margin: '0 auto',
				padding: '30px',
				display: 'flex',
				flexDirection: 'column',
				gap: '10px',
			}}
		>
			<Lottie animationData={animationData} style={{ width: '160px' }} />
			<h1>UI KIT</h1>

			<h3>Default input</h3>
			{/* <CustomInput label="Label"/>
			<h3>size xs</h3>
			<CustomInput label="Label" size="xs" />
			<h3>size sm</h3>
			<CustomInput label="Label" size="sm" />
			<h3>size md</h3>
			<CustomInput label="Label" size="md" />
			<h3>size lg</h3>
			<CustomInput label="Label" size="lg" />
			<h3>Disabled</h3>
			<CustomInput label="Label" isDisabled />
			<h3>Invalid</h3>
			<CustomInput label="Label" isInvalid />
			<h3>Left icon</h3>
			<CustomInput label="Label" leftIcon={<Search2Icon color="gray.300" />} />
			<h3>Rigth icon</h3>
			<CustomInput label="Label" rightIcon={<Search2Icon color="gray.300" />} /> */}
			<br />
			<h3>Default select</h3>
			<CustomSelect
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<h3>size small</h3>
			<CustomSelect
				size="small"
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<h3>size middle</h3>
			<CustomSelect
				size="middle"
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<h3>size large</h3>
			<CustomSelect
				size="large"
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<h3>Disabled</h3>
			<CustomSelect
				isDisabled
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<h3>Invalid</h3>
			<CustomSelect
				isInvalid
				label="Label"
				options={[
					{ label: 'label 1', value: 'value 1' },
					{ label: 'label 2', value: 'value 2' },
					{ label: 'label 3', value: 'value 3' },
				]}
			/>
			<Button onClick={() => setIsOpen(true)}>open modal</Button>
			{isOpen && (
				<SideModal
					isOpen={isOpen}
					onClose={() => setIsOpen(false)}
					onBlur={() => setIsOpen(false)}
					footer="footer"
					title="title"
				>
					test
				</SideModal>
			)}
		</div>
	);
};
